/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantFidelizationSummary {
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  costPrice?: number;
  defaultImageURL?: string;
  displayOrder?: number;
  expiration?: string;
  externalId?: number;
  internalEAN?: string;
  invoicePrice?: number;
  maxTradesPerPerson?: number;
  productVariantId?: number;
  productVariantName?: string;
  ratingAverage?: number;
  reviewCount?: number;
  salePrice?: number;
  stock?: number;
  tradePoints?: number;
  tradeable?: boolean;
  weight?: number;
}
